import styled from 'styled-components';

export const TripInfoDetailsInnerWrap = styled.div(
    props => `
        width:75%;
        display: flex;
        flex-direction: column;
    `
);

export const TripDetailOuterWrap = styled.div(
    props => `
        display: flex;
        align-items: flex-start;
    `
);

export const TripDetailsWrap = styled.div(
    props => `
        width:25%;
        display: flex;
        flex-direction: column;
    `
);

export const CheckText = styled.p(
    props => `
        font-size: ${props.theme.font.large.font14};
        color: ${props.theme.colors.grey.dark74}; 
        text-transform: uppercase;
    `
);

export const DateText = styled.p(
    props => `
        font-size: ${props.theme.font.large.font16};
        color: ${props.theme.colors.grey.base};
        font-weight: ${props.theme.font.fontWeight.black};
        padding-top: ${props.theme.spacing.small.s8};
        padding-bottom: ${props.theme.spacing.small.s5};
        span{
            font-size: ${props.theme.font.large.font14};
            color: ${props.theme.colors.grey.dark74};
        }
    `
);

export const CheckTime = styled.p(
    props => `
        font-size: ${props.theme.font.large.font14};
        color: ${props.theme.colors.grey.base};
        font-weight: ${props.theme.font.fontWeight.bold};
    `
);

export const RoomInfoText = styled.p(
    props => `
        font-size: ${props.theme.font.large.font14};
        color: ${!props.completed ? props.theme.colors.blue.base : props.theme.colors.grey.base};
        font-weight: ${props.theme.font.fontWeight.bold};
        padding-top: ${props.theme.spacing.large.l27};
    `
);

export const TravellerInfoText = styled.p(
    props => `
        font-size: ${props.theme.font.large.font14};
        color: ${props.theme.colors.grey.base};
        font-weight: ${props.theme.font.fontWeight.bold};
        padding-top: ${props.theme.spacing.small.s5};
    `
);

export const RoomImg = styled.img(
    props => `
        width:7rem;
        height: 7rem;
        border-radius: 0.3rem;
    `
);

export const TripAdditionInfoWrap = styled.div(
    props => `
        display: flex;
        align-items: center;
        padding-top: ${props.theme.spacing.large.l25};
    `
);

export const TripAdditionInfoInnerWrap = styled.div(
    props => `
        display: flex;
        align-items: center;
        justify-content: center;
    `
);

export const FreeCancelIcon = styled.div(
    props => `
        width:2.3rem;
        margin-right: ${props.theme.spacing.base};
    `
);

export const FreeCancelText = styled.p(
    props => `
        font-size: ${props.theme.font.large.font14};
        color: ${props.theme.colors.grey.dark74};
        font-weight: ${props.theme.font.fontWeight.bold};
    `
);